<span class="icon bpi__icon-attention"></span>
<ng-content></ng-content>
